import React from 'react';
import { Plus } from 'lucide-react';

interface AddNewButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  label?: string;
}

const AddNewButton: React.FC<AddNewButtonProps> = ({
  onClick,
  variant = 'primary',
  label = 'Add New',
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`cg-btn ${variant === 'primary' ? 'cg-btn-primary' : 'cg-btn-ghost'} gap-1.5`}
  >
    <Plus className="w-3.5 h-3.5" />
    <span>{label}</span>
  </button>
);

export default AddNewButton;
